import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {
  StrainDetails,
  StrainDetailsModal,
  RecentBatchesListing,
  RecentBatchesListingQueryParameters,
} from "./type";

const initialState: StrainDetailsModal = {
  strainBatchesListing: {
    data: [],
    total: 0,
    limit: 0,
    pageNo: 0,
    nextHit: 0,
    totalPage: 0,
  },

  recentBatchesListingQueryParameters: {
    pageNo: 1,
    limit: 5,
    sortBy: 0,
    sortCrietria: "myCollection",
  },

  hasMoreBatches: false,

  strainDetails: {
    _id: "",
    strainId: "",
    strainName: "",
    imageUrl: "",
    lineage: [],
    feelings: [],
    status: "",
    addedBy: "",
    strainType: "",
    created: 0,
    createdAt: "",
    updatedAt: "",
    productImage: "",
    description: "",
    companyName: "",
    companyPicture: "",
    manufacturerId: "",
    normalizedStrainName: "",
  },
};

const strainDetailsSlice = createSlice({
  name: "strainDetails",
  initialState,
  reducers: {
    setStrainDetails: (
      state: StrainDetailsModal,
      action: PayloadAction<StrainDetails>,
    ) => {
      state.strainDetails = action.payload;
    },

    setResetStrainDetails: (state: StrainDetailsModal) => {
      state.strainDetails = {
        _id: "",
        strainId: "",
        strainName: "",
        imageUrl: "",
        normalizedStrainName: "",
        lineage: [],
        feelings: [],
        status: "",
        addedBy: "",
        manufacturerId: "",
        created: 0,
        createdAt: "",
        updatedAt: "",
        productImage: "",
        description: "",
        strainType: "",
        companyName: "",
        companyPicture: "",
      };
    },

    setStrainBatchesListing: (
      state: StrainDetailsModal,
      action: PayloadAction<RecentBatchesListing>,
    ) => {
      const newPayload: RecentBatchesListing = action.payload;

      state.strainBatchesListing = {
        ...newPayload,
        data: [...state.strainBatchesListing.data, ...newPayload.data],
      };
      state.hasMoreBatches = newPayload.totalPage > newPayload.pageNo;
    },

    setResetStrainBatchesListing: (state: StrainDetailsModal) => {
      state.strainBatchesListing = {
        data: [],
        total: 0,
        limit: 10,
        pageNo: 1,
        nextHit: 0,
        totalPage: 0,
      };
      state.hasMoreBatches = false;

      state.recentBatchesListingQueryParameters = {
        pageNo: 1,
        limit: 5,
        sortBy: 0,
        sortCrietria: "myCollection",
      };
    },

    setRecentBatchesListingQueryParameters: (
      state: StrainDetailsModal,
      action: PayloadAction<RecentBatchesListingQueryParameters>,
    ) => {
      state.recentBatchesListingQueryParameters = {
        ...action.payload,
      };
    },
  },
});

export const {
  setStrainDetails,
  setResetStrainDetails,
  setStrainBatchesListing,
  setResetStrainBatchesListing,
  setRecentBatchesListingQueryParameters,
} = strainDetailsSlice.actions;
export default strainDetailsSlice.reducer;
